import Vue from "vue";

interface Dialog {
  visible?: boolean;
  title?: string;
  content?: string;
  cancelBtn?: boolean;
  confirmBtn?: boolean;
  fun?: Function;
}

const confirmDialog = {
  namespaced: true,
  state: {
    visible: false,
    title: "",
    content: "",
    cancelBtn: true,
    confirmBtn: true
  } as Dialog,
  mutations: {
    setVisible(state: Dialog, visible: boolean) {
      Vue.set(state, "visible", visible);
      state.visible = visible;
    },
    setAttr(state: Dialog, options: Dialog) {
      Vue.set(state, "title", options.title);
      Vue.set(state, "content", options.content);
      Vue.set(state, "cancelBtn", options.cancelBtn);
      Vue.set(state, "confirmBtn", options.confirmBtn);
    }
  },
  actions: {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    openConfirm(context: any, option: Dialog) {
      context.commit("serAttr", option);
      context.commit("setVisible", true);
    }
  }
};

export default confirmDialog;
